import React from 'react';
import shippingBoxTinyNudgeIcon from '@reverbdotcom/commons/design-system/icons/nudge/shipping-box--tiny.svg';
import gemTinyNudgeIcon from '@reverbdotcom/commons/design-system/icons/nudge/gem--tiny.svg';
import fastTruckTinyNudgeIcon from '@reverbdotcom/commons/design-system/icons/nudge/fast-truck-tiny.svg';
import locationPinTinyNudgeIcon from '@reverbdotcom/commons/design-system/icons/nudge/location-pin--tiny.svg';
import cartTinyNudgeIcon from '@reverbdotcom/commons/design-system/icons/nudge/cart--tiny.svg';
import { I18N } from './translate';
import { useExpEnabled } from '../user_hooks';
import experiments from '../experiments';

interface IProps {
  displayMultiple?: boolean;
  freeExpeditedShipping?: boolean;
  freeShipping?: boolean;
  greatValue?: boolean;
  inOtherCartsCount: number;
  localPickupOnly?: boolean;
  localPickupAvailable?: boolean;
  returnPolicyDays: number;
}

ListingCardNudge.defaultProps = {
  inOtherCartsCount: 0,
  returnPolicyDays: 0,
};

function getNudgesToDisplay(props, greatValueUKEnabled) {
  const applicableNudges = [];

  if (greatValueUKEnabled && props.greatValue) {
    applicableNudges.push({ i18key: 'greatValue', icon: gemTinyNudgeIcon });
    return applicableNudges;
  }

  if (props.freeExpeditedShipping) { applicableNudges.push({ i18key: 'freeExpeditedShipping', icon: fastTruckTinyNudgeIcon }); }
  if (props.freeShipping && !props.freeExpeditedShipping) { applicableNudges.push({ i18key: 'freeShipping', icon: fastTruckTinyNudgeIcon }); }
  if (props.returnPolicyDays >= 14) { applicableNudges.push({ i18key: 'returnPolicy', icon: shippingBoxTinyNudgeIcon }); }
  if (props.inOtherCartsCount > 0) { applicableNudges.push({ i18key: 'inOtherCarts', icon: cartTinyNudgeIcon }); }
  if (props.localPickupOnly) { applicableNudges.push({ i18key: 'localPickup', icon: locationPinTinyNudgeIcon }); }
  if (props.localPickupAvailable) { applicableNudges.push({ i18key: 'localPickupAvailable', icon: locationPinTinyNudgeIcon }); }
  if (props.greatValue) { applicableNudges.push({ i18key: 'greatValue', icon: gemTinyNudgeIcon }); }
  return applicableNudges.slice(0, props.displayMultiple ? 2 : 1);
}

function getDisplayTextArgs(i18key, props) {
  if (i18key === 'returnPolicy') return ({ returnPolicyDays: (props.returnPolicyDays || 0) });
  if (i18key === 'inOtherCarts') return ({ count: (props.inOtherCartsCount) });
  return {};
}

// DEPRECATED. Please use ListingCardSignals as it uses the signal system instead of client logic to calculate signals.
export default function ListingCardNudge(props: IProps) {
  const greatValueUKEnabled = useExpEnabled(experiments.GREAT_VALUE_BADGE_UK);
  const nudgesToDisplay = getNudgesToDisplay(props, greatValueUKEnabled);
  if (!nudgesToDisplay.length) return null;

  return (
    <>
      {nudgesToDisplay.map(displayHash => {
        return (
          <div className="listing-card-nudge" key={displayHash.i18key}>
            <img src={displayHash.icon} alt="" />
            <I18N
              text={`commons.listingCardNudge.${displayHash.i18key}`}
              args={getDisplayTextArgs(displayHash.i18key, props)}
            />
          </div>
        );
      })}
    </>
  );
}
